import {AgreementInfoVo} from '../../common/shared/api/nicolas/vo/AgreementInfoVo.interface';
import {AgreementInfo} from '../generated/types';
import {createAgreement} from './Agreement';
import {createAgreementType} from './AgreementType';

export function createAgreementInfo(
  agreementInfoVo: AgreementInfoVo,
  isWebView: boolean
): AgreementInfo {
  const agreements = agreementInfoVo.agreement_layout.map(agreementVo =>
    createAgreement(agreementVo, isWebView)
  );
  const agreementUnder14 = agreementInfoVo.agreement_under_14 && {
    title: agreementInfoVo.agreement_under_14.alert_title,
    itemList: agreementInfoVo.agreement_under_14.agreement_layout.map(
      agreementVo => createAgreement(agreementVo, isWebView)
    ),
    atLeast14AgeType: createAgreementType(agreementInfoVo.at_least_14_type),
  };

  return {
    isRegistered: agreementInfoVo.is_registered,
    agreement: {
      itemList: agreements,
    },
    agreementUnder14,
  };
}
